export const init_level = {
    'levelName': "",
    'valueType': "",
    'priceType': 'percent',
    'adult': "",
    'kid': "",
    'infant': "",
    'actived': false,
}